import type {ReactNode} from 'react';

import {describeError} from '../utils/describeError';

export type NoticeTone = 'error' | 'warning' | 'info';

/**
 * A callout: one line that says what happened, and under it, when there is more to say, the body
 * — always visible, never behind a disclosure. Tinted by tone, with a mark before the line.
 */
export const Notice = ({
    tone = 'info',
    message,
    children,
}: {
    tone?: NoticeTone;
    message: string;
    children?: ReactNode;
}) => (
    <div className={`sd-notice sd-notice-${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
        <span className="sd-notice-mark" aria-hidden="true">
            {tone === 'info' ? 'i' : '!'}
        </span>
        <div className="sd-notice-body">
            <span className="sd-notice-message">{message}</span>
            {children !== undefined && children !== null && (
                <div className="sd-notice-detail">{children}</div>
            )}
        </div>
    </div>
);

/** A failed request: the title says what could not be done, the body says why. */
export const ErrorNotice = ({title, error}: {title: string; error: unknown}) => (
    <Notice tone="error" message={title}>
        {describeError(error)}
    </Notice>
);
